






















import { Component, Vue } from 'vue-property-decorator';
import { getCurrentDate } from '@/utils/date';
import NavButton from './components/NavButton.vue';

@Component({
  name: 'Home',
  components: {
    NavButton,
  },
})
export default class extends Vue {
  private date = '';

  created() {
    this.date = getCurrentDate();
  }

  private gotoAssginFilterPage() {
    this.$router.push({ name: 'AssginFilter' });
  }

  private gotoPickupPage() {
    this.$router.push({ name: 'PickupFilter' });
  }
}
